/// FOURJS_START_COPYRIGHT(D,2025)
/// Property of Four Js*
/// (c) Copyright Four Js 2025, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

const ESC_MAP = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};

/**
 *
 * @namespace classes.StringHelper
 */
const StringHelper = /** @lends classes.StringHelper*/ {
  getBytesCount: function (string) {
    const log = Math.log(256);
    let total = 0;
    for (let i = 0; i < string.length; i++) {
      const charCode = string.codePointAt(i);
      total += Math.ceil(Math.log(charCode) / log);
    }
    return total;
  },

  /**
   * generate a random hexadecimal string
   * @param length
   * @returns {string}
   */
  random: function (length = 16) {
    const bytes = new Uint8Array(Math.ceil(length / 2));
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes)
      .map((byte) => byte.toString(16).padStart(2, "0"))
      .join("")
      .slice(0, length);
  },

  // escape most problematic html chars from the string
  escapeHTML: function (string) {
    return string.replaceAll(/[&<>'"]/g, function (c) {
      return ESC_MAP[c];
    });
  },

  /**
   * put quote around font name when it contains a space
   * @return {string}
   */
  escapeFontFamily: function (string) {
    let fontList = [];

    fontList = string.split(",").map(function (font) {
      return font.includes(" ") ? '"' + font.trim() + '"' : font;
    });

    return fontList.join(",");
  },

  /**
   * The splice() method changes the content of a string by removing a range of
   * characters and/or adding new characters.
   *
   * @this {String}
   * @param {number} start Index at which to start changing the string.
   * @param {number} delCount An integer indicating the number of old chars to remove.
   * @param {string} newSubStr The String that is spliced in.
   * @return {string} A new string with the spliced substring.
   */
  splice: function (string, start, delCount, newSubStr) {
    return string.slice(0, start) + newSubStr + string.slice(start + Math.abs(delCount));
  },

  /**
   * Checks if the unicode char code belongs to the encoding table
   * @param table table of authorized utf-16 codes
   * @param charCode utf-16 char code
   * @return {boolean} true if the char exist in the table
   */
  charExistsInEncoding: function (table, charCode) {
    for (let i = 0; i < table.length && table[i][0] <= charCode; i++) {
      if (table[i][0] <= charCode && charCode <= table[i][1]) {
        return true;
      }
    }
    return false;
  }
};

modulum("StringHelper", function (context, cls) {
  cls.StringHelper = StringHelper;
});

if (typeof module !== "undefined" && module.exports) {
  module.exports = StringHelper;
}
